import React from "react";
import styled from "styled-components";

import { OnboardingNew } from "../../../content/assets";
import { AppButton, AppLogo, AppText } from "../../ui";
import theme from "../../../util/theme";
import { Link } from "gatsby";
import { LottieVideo } from "../Segments";
import { mobileSize } from "../../../util/variables";

const NewOnboardingStart = () => {
  return (
    <Container>
      <LottieContainer>
        <LottieVideo lottieJSON={OnboardingNew} />
      </LottieContainer>
      <AppLogo width={192} />
      <H2>Learn Visually</H2>
      <Link
        to="/onboarding/questions"
      // onClick={() => fbq("trackCustom", "start_questions")}
      >
        <AppButton>Get Started</AppButton>
      </Link>
      <AppText color={theme.PRIMARY_COLOR} fontSize={14}>
        Already have an account? <LoginButton>Log in</LoginButton>
      </AppText>
    </Container>
  );
};

const Container = styled.div`
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #e8e8e8;
`;

const LottieContainer = styled.div`
  max-height: 72vh;
  width: 100%;
  flex-shrink: 1;
  @media ${mobileSize} {
    max-height: 65vh;
  }
`;

const H2 = styled.h2`
  margin: 10px 0 30px;
  font-size: 20px;
  color: ${theme.SLATE_COLOR};
  text-transform: uppercase;
`;

const LoginButton = styled.button`
  border: none;
  background: none;
  font-size: 14px;
  font-weight: bold;
  text-decoration: underline;
`;

export { NewOnboardingStart };
